<template>
  <v-card class="mx-auto" elevation="16" max-width="100hv">
    <v-card-item>
      <v-card-title> Gallery / Galería </v-card-title>
      <v-card-subtitle>
        <div v-if="language == 'EN'">
          <h3>You are in the section to update only in English</h3>
          <h3>English</h3>
          <button @click="changeLanguage()" class="action-btn secondary-btn">
            <span class="language-tag">Change Language</span>
            {{ language == "EN" ? "ES" : "EN" }}
          </button>
        </div>

        <div v-else>
          <h3>Estas actualizando la sección en</h3>
          <h3>Español</h3>
          <button @click="changeLanguage()" class="action-btn secondary-btn">
            <span class="language-tag">Cambiar idioma</span>
            {{ language == "ES" ? "EN" : "ES" }}
          </button>
        </div>
      </v-card-subtitle>
    </v-card-item>
    <v-card-text>
      <v-row class="gap-y-6">
        <div class="operations-page width100">
          <section class="about-hero">
            <div class="about-info-title">
              <div>
                <h1
                  class="h-big"
                  style="color: white !important"
                  @dblclick="openEditModal('GALLERY_01_' + language)"
                >
                  <span v-html="filterData('GALLERY_01_' + language)"></span>
                </h1>
              </div>
            </div>
          </section>

          <section class="gallery-section">
            <div class="about-info">
              <!-- Sección Lixiviación -->
              <div class="gallery-container">
                <v-row>
                  <v-col cols="12" md="6">
                    <div>
                      <h2
                        class="gallery-title"
                        @dblclick="openEditModal('GALLERY_02_' + language)"
                      >
                        <span
                          v-html="filterData('GALLERY_02_' + language)"
                        ></span>
                      </h2>
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    style="
                      display: flex;
                      justify-content: flex-end;
                      align-items: start;
                      margin-top: 10px;
                    "
                  >
                    <button
                      class="action-btn secondary-btn"
                      @click="openModalVideo('V_GALLERY_A_')"
                    >
                      Agregar Video
                    </button>
                  </v-col>
                </v-row>
                <div class="gallery-grid">
                  <div
                    v-for="(image, index) in imagesHidro"
                    :key="index"
                    class="gallery-item"
                    @dblclick="openEditImageModal(image)"
                  >
                    <v-img
                      :src="searchImage(image)"
                      class="gallery-image"
                      aspect-ratio="1"
                      cover
                    ></v-img>
                  </div>
                </div>
                <div v-if="v_gallery_a.length > 0">
                  <div class="gallery-grid">
                    <div
                      v-for="(video, index) in v_gallery_a"
                      :key="index"
                      class="gallery-item video-container"
                    >
                      <iframe
                        controls
                        :src="getEmbedUrl(video.image_path)"
                        class="gallery-image"
                        style="background-position: center"
                        aspect-ratio="16/9"
                        cover
                        muted
                      ></iframe>
                      <button
                        class="delete-video-btn"
                        @click="deleteVideo(video)"
                        title="Eliminar video"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Sección Mina -->
              <div class="gallery-container">
                <v-row>
                  <v-col cols="12" md="6">
                    <h2
                      class="gallery-title"
                      @dblclick="openEditModal('GALLERY_03_' + language)"
                    >
                      <span
                        v-html="filterData('GALLERY_03_' + language)"
                      ></span>
                    </h2>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    style="
                      display: flex;
                      justify-content: flex-end;
                      align-items: start;
                      margin-top: 10px;
                    "
                  >
                    <button
                      class="action-btn secondary-btn"
                      @click="openModalVideo('V_GALLERY_B_')"
                    >
                      Agregar Video
                    </button>
                  </v-col>
                </v-row>
                <div class="gallery-grid">
                  <div
                    v-for="(image, index) in imagesMina"
                    :key="index"
                    class="gallery-item"
                    @dblclick="openEditImageModal(image)"
                  >
                    <v-img
                      :src="searchImage(image)"
                      class="gallery-image"
                      aspect-ratio="1"
                      cover
                    ></v-img>
                  </div>
                </div>
                <div v-if="v_gallery_b.length > 0">
                  <div class="gallery-grid">
                    <div
                      v-for="(video, index) in v_gallery_b"
                      :key="index"
                      class="gallery-item video-container"
                    >
                      <iframe
                        controls
                        :src="getEmbedUrl(video.image_path)"
                        class="gallery-image video-delete"
                        style="background-position: center"
                        aspect-ratio="16/9"
                        cover
                        muted
                      ></iframe>
                      <button
                        class="delete-video-btn"
                        @click="deleteVideo(video)"
                        title="Eliminar video"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Sección Trituración -->
              <div class="gallery-container">
                <v-row>
                  <v-col cols="12" md="6">
                    <div>
                      <h2
                        class="gallery-title"
                        @dblclick="openEditModal('GALLERY_04_' + language)"
                      >
                        <span
                          v-html="filterData('GALLERY_04_' + language)"
                        ></span>
                      </h2>
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    style="
                      display: flex;
                      justify-content: flex-end;
                      align-items: start;
                      margin-top: 10px;
                    "
                  >
                    <button
                      class="action-btn secondary-btn"
                      @click="openModalVideo('V_GALLERY_C_')"
                    >
                      Agregar Video
                    </button>
                  </v-col>
                </v-row>
                <div class="gallery-grid">
                  <div
                    v-for="(image, index) in imagesTrituracion"
                    :key="index"
                    class="gallery-item"
                    @dblclick="openEditImageModal(image)"
                  >
                    <v-img
                      :src="searchImage(image)"
                      class="gallery-image"
                      aspect-ratio="1"
                      cover
                    />
                  </div>
                </div>
                <div v-if="v_gallery_c.length > 0">
                  <div class="gallery-grid">
                    <div
                      v-for="(video, index) in v_gallery_c"
                      :key="index"
                      class="gallery-item video-container"
                    >
                      <iframe
                        controls
                        :src="getEmbedUrl(video.image_path)"
                        class="gallery-image"
                        style="background-position: center"
                        aspect-ratio="16/9"
                        cover
                        muted
                      ></iframe>
                      <button
                        class="delete-video-btn"
                        @click="deleteVideo(video)"
                        title="Eliminar video"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- Lightbox Modal -->
          <div v-if="showLightbox" class="lightbox" @click="closeLightbox">
            <div class="lightbox-content">
              <img :src="searchImage(currentImage)" alt="Gallery image" />
              <button class="close-btn" @click.stop="closeLightbox">×</button>
            </div>
          </div>
        </div>
      </v-row>
    </v-card-text>
  </v-card>
  <UpdateModal
    :visible="dialogVisible"
    :current-text="currentText"
    current-page="GALLERY"
    :text-id="currentTextId"
    @update:visible="updateDialogVisible"
    @save-text="updateText"
  />
  <ModalUpdateImage
    :is-visible-image-u="dialogVisibleImage"
    :image-id="currentImageId"
    image-section="GALLERY"
    @update:visible="updateDialogVisibleImage"
    @update:files="getImages"
  />
  <ModalAddLinkVideo
    :is-visible-video-u="isVisibleVideoU"
    :video-section="videoSection"
    @update:visible="closeModalVideo"
    @update:files="getImages"
  />
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import {
  BASEURL,
  getLanguageForUpdateContent,
  setLanguageForUpdateContent,
} from "@/kernel/utils";
import {
  showInfoToast,
  showErrorToast,
  showSuccessToast,
} from "@/kernel/alerts";
import UpdateModal from "../../components/UpdateModal.vue";
import {
  getSectionByPageandlanguage,
  getImageBySection,
  deleteVideoService,
} from "../../services/sections-service";
import ModalUpdateImage from "../../components/ModalUpdateImage.vue";
import ModalAddLinkVideo from "../../components/ModalAddLinkVideo.vue";

export default defineComponent({
  name: "UpdateAboutEn",
  components: {
    UpdateModal,
    ModalUpdateImage,
    ModalAddLinkVideo,
  },
  setup() {
    const language = ref(getLanguageForUpdateContent());
    const selectedImage = ref(null);
    const modalVisible = ref(false);

    const imagesHidro = ref([
      "GALLERY_A_01",
      "GALLERY_A_02",
      "GALLERY_A_03",
      "GALLERY_A_04",
      "GALLERY_A_05",
      "GALLERY_A_06",
      "GALLERY_A_07",
      "GALLERY_A_08",
      "GALLERY_A_09",
      "GALLERY_A_10",
      "GALLERY_A_11",
      "GALLERY_A_12",
      "GALLERY_A_13",
      "GALLERY_A_14",
      "GALLERY_A_15",
      "GALLERY_A_16",
      "GALLERY_A_17",
      "GALLERY_A_18",
      "GALLERY_A_19",
      "GALLERY_A_20",
      "GALLERY_A_21",
      "GALLERY_A_22",
      "GALLERY_A_23",
      "GALLERY_A_24",
      "GALLERY_A_25",
      "GALLERY_A_26",
      "GALLERY_A_27",
      "GALLERY_A_28",
      "GALLERY_A_29",
      "GALLERY_A_30",
    ]);

    const imagesMina = ref([
      "GALLERY_B_01",
      "GALLERY_B_02",
      "GALLERY_B_03",
      "GALLERY_B_04",
      "GALLERY_B_05",
      "GALLERY_B_06",
      "GALLERY_B_07",
      "GALLERY_B_08",
      "GALLERY_B_09",
      "GALLERY_B_10",
      "GALLERY_B_11",
      "GALLERY_B_12",
      "GALLERY_B_13",
      "GALLERY_B_14",
      "GALLERY_B_15",
      "GALLERY_B_16",
      "GALLERY_B_17",
      "GALLERY_B_18",
      "GALLERY_B_19",
      "GALLERY_B_20",
      "GALLERY_B_21",
      "GALLERY_B_22",
      "GALLERY_B_23",
      "GALLERY_B_24",
      "GALLERY_B_25",
      "GALLERY_B_26",
      "GALLERY_B_27",
      "GALLERY_B_28",
      "GALLERY_B_29",
      "GALLERY_B_30",
    ]);

    const imagesTrituracion = ref([
      "GALLERY_C_01",
      "GALLERY_C_02",
      "GALLERY_C_03",
      "GALLERY_C_04",
      "GALLERY_C_05",
      "GALLERY_C_06",
      "GALLERY_C_07",
      "GALLERY_C_08",
      "GALLERY_C_09",
      "GALLERY_C_10",
      "GALLERY_C_11",
      "GALLERY_C_12",
      "GALLERY_C_13",
      "GALLERY_C_14",
      "GALLERY_C_15",
      "GALLERY_C_16",
      "GALLERY_C_17",
      "GALLERY_C_18",
      "GALLERY_C_19",
      "GALLERY_C_20",
      "GALLERY_C_21",
      "GALLERY_C_22",
      "GALLERY_C_23",
      "GALLERY_C_24",
      "GALLERY_C_25",
      "GALLERY_C_26",
      "GALLERY_C_27",
      "GALLERY_C_28",
      "GALLERY_C_29",
      "GALLERY_C_30",
    ]);

    // Lightbox functionality
    const showLightbox = ref(false);
    const currentImage = ref("");

    const openLightbox = (image) => {
      currentImage.value = image;
      showLightbox.value = true;
      document.body.style.overflow = "hidden";
    };

    const closeLightbox = () => {
      showLightbox.value = false;
      document.body.style.overflow = "auto";
    };

    const dataGallery = ref([
      {
        section_id: "GALLERY_01_EN",
        description: "Gallery",
      },
      {
        section_id: "GALLERY_01_ES",
        description: "Galería",
      },
      {
        section_id: "GALLERY_02_EN",
        description: "Leaching and SX/EW",
      },
      {
        section_id: "GALLERY_02_ES",
        description: "Lixiviación y SX/EW",
      },
      {
        section_id: "GALLERY_03_EN",
        description: "Mine",
      },
      {
        section_id: "GALLERY_03_ES",
        description: "Mina",
      },
      {
        section_id: "GALLERY_04_EN",
        description: "Crushing System",
      },
      {
        section_id: "GALLERY_04_ES",
        description: "Sistema de trituración",
      },
    ]);

    const fetchData = async () => {
      try {
        const dataForm = {
          page: "GALLERY",
          language: language.value,
        };
        const response = await getSectionByPageandlanguage(dataForm);
        if (response.status === 200) {
          if (parseInt(response.data.length) !== 0) {
            dataGallery.value = response.data;
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const filterData = (found_id) => {
      const filteredData = dataGallery.value.filter(
        (item) => item.section_id === found_id
      );
      return filteredData.length > 0 ? filteredData[0].description : null;
    };

    const defaultImages = [
      { id: "GALLERY_A_01", path: "hidrometalurgia-01.jpg" },
      { id: "GALLERY_A_02", path: "hidrometalurgia-02.jpg" },
      { id: "GALLERY_A_03", path: "hidrometalurgia-03.jpg" },
      { id: "GALLERY_A_04", path: "hidrometalurgia-04.jpg" },
      { id: "GALLERY_A_05", path: "hidrometalurgia-05.jpg" },
      { id: "GALLERY_A_06", path: "hidrometalurgia-06.jpg" },
      { id: "GALLERY_B_01", path: "mina-01.jpg" },
      { id: "GALLERY_B_02", path: "mina-03.jpg" },
      { id: "GALLERY_B_03", path: "mina-04.jpg" },
      { id: "GALLERY_B_04", path: "mina-05.jpg" },
      { id: "GALLERY_B_05", path: "mina-06.jpg" },
      { id: "GALLERY_C_01", path: "trituracion-01.jpg" },
      { id: "GALLERY_C_02", path: "trituracion-02.jpg" },
      { id: "GALLERY_C_03", path: "trituracion-03.jpg" },
      { id: "GALLERY_C_04", path: "trituracion-04.jpg" },
    ];

    // Ajustar el nombre de la variable de galería cargada dinámicamente
    const imagesGallery = ref([]);

    // Esta función ahora intenta buscar una imagen dinámica y si no existe, retorna la ruta default
    const searchImage = (imageId) => {
      const foundDynamic = imagesGallery.value.find(
        (img) => img.image_id === imageId
      );
      if (foundDynamic) return `${BASEURL}${foundDynamic.image_path}`;

      const foundDefault = defaultImages.find((img) => img.id === imageId);
      if (foundDefault) return `${BASEURL}/img/gallery/${foundDefault.path}`;

      // Si tampoco está en default, puedes retornar una imagen fallback genérica
      return `${BASEURL}/img/gallery/placeholder.jpg`;
    };

    const getImages = async () => {
      try {
        const dataForm = {
          page: "GALLERY",
        };
        const result = await getImageBySection(dataForm);
        if (result.status === 200) {
          if (result.data.content !== null) {
            imagesGallery.value = result.data.content;
            searchVideos();
          }
        }
      } catch (error) {
        console.log("Error fetching images:", error);
      }
    };

    const v_gallery_a = ref([]);
    const v_gallery_b = ref([]);
    const v_gallery_c = ref([]);

    const searchVideos = () => {
      v_gallery_a.value = [];
      v_gallery_b.value = [];
      v_gallery_c.value = [];

      imagesGallery.value.forEach((img) => {
        const imageId = img.image_id || "";

        if (imageId.startsWith("V_GALLERY_A_")) {
          v_gallery_a.value.push(img);
        } else if (imageId.startsWith("V_GALLERY_B_")) {
          v_gallery_b.value.push(img);
        } else if (imageId.startsWith("V_GALLERY_C_")) {
          v_gallery_c.value.push(img);
        }
      });
    };

    // Función para eliminar video
    const deleteVideo = async (video) => {
      try {
        // Mostrar confirmación antes de eliminar
        if (confirm("¿Estás seguro de que quieres eliminar este video?")) {
          const result = await deleteVideoService({
            video_id: video.id,
          });
          if (result.status === 200) {
            showSuccessToast("Video eliminado correctamente");
            getImages(); // Recargar la galería
          }
        }
      } catch (error) {
        console.error("Error al eliminar video:", error);
        showErrorToast("Error al eliminar el video");
      }
    };

    onMounted(() => {
      fetchData();
      getImages();
    });

    const changeLanguage = () => {
      const lang = getLanguageForUpdateContent() === "EN" ? "ES" : "EN";
      setLanguageForUpdateContent(lang);
      showInfoToast(
        `Language changed to ${lang === "EN" ? "English" : "Spanish"}`
      );
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    };

    const dialogVisible = ref(false);
    const currentText = ref("");
    const currentTextId = ref("");

    const updateDialogVisible = (visible) => {
      dialogVisible.value = visible;
    };

    const updateText = ({ id, text }) => {
      const index = dataGallery.value.findIndex(
        (item) => item.section_id === id
      );
      if (index !== -1) {
        dataGallery.value[index].description = text;
      }
    };

    const openEditModal = (textId) => {
      showInfoToast(`Double click to edit the text: ${textId}`);
      const textToEdit = filterData(textId);
      currentText.value = textToEdit;
      currentTextId.value = textId;
      dialogVisible.value = true;
    };

    const dialogVisibleImage = ref(false);
    const currentImageId = ref("");

    const updateDialogVisibleImage = (visible) => {
      dialogVisibleImage.value = visible;
    };

    const openEditImageModal = (imageId) => {
      showInfoToast(`Double click to edit the image: ${imageId}`);
      currentImageId.value = imageId;
      dialogVisibleImage.value = true;
    };

    const isVisibleVideoU = ref(false);
    const videoSection = ref("");

    const openModalVideo = (zone) => {
      isVisibleVideoU.value = true;
      videoSection.value = zone;
    };

    const closeModalVideo = () => {
      isVisibleVideoU.value = false;
    };

    const getEmbedUrl = (url) => {
      if (!url) return "";

      // YouTube
      if (url.includes("youtube.com") || url.includes("youtu.be")) {
        const id = url.match(/(?:v=|\/)([0-9A-Za-z_-]{11})/)?.[1];
        return id ? `https://www.youtube.com/embed/${id}` : "";
      }

      // Vimeo
      if (url.includes("vimeo.com")) {
        const id = url.match(/vimeo\.com\/(?:video\/)?(\d+)/)?.[1];
        return id ? `https://player.vimeo.com/video/${id}` : "";
      }

      //Tiktok
      if (url.includes("tiktok.com")) {
        const id = url.match(/tiktok\.com\/(?:video\/)?(\d+)/)?.[1];
        return id ? `https://www.tiktok.com/embed/${id}` : "";
      }

      // Twitch
      if (url.includes("twitch.tv")) {
        const id = url.match(/twitch\.tv\/(?:video\/)?(\d+)/)?.[1];
        return id ? `https://player.twitch.tv/?video=${id}` : "";
      }

      // Dailymotion
      if (url.includes("dailymotion.com")) {
        const id = url.match(/dailymotion\.com\/(?:video\/)?(\d+)/)?.[1];
        return id ? `https://www.dailymotion.com/embed/video/${id}` : "";
      }

      // Facebook
      if (url.includes("facebook.com")) {
        const id = url.match(/facebook\.com\/(?:video\/)?(\d+)/)?.[1];
        return id ? `https://www.facebook.com/embed/${id}` : "";
      }

      // Instagram
      if (url.includes("instagram.com")) {
        const id = url.match(/instagram\.com\/(?:video\/)?(\d+)/)?.[1];
        return id ? `https://www.instagram.com/embed/${id}` : "";
      }

      return url; // fallback
    };

    return {
      BASEURL,
      language: getLanguageForUpdateContent(),
      changeLanguage,
      filterData,
      openEditModal,
      updateDialogVisible,
      updateText,
      dialogVisible,
      currentText,
      currentTextId,
      selectedImage,
      modalVisible,
      searchImage,
      updateDialogVisibleImage,
      openEditImageModal,
      dialogVisibleImage,
      currentImageId,
      getImages,
      imagesGallery,
      defaultImages,
      imagesHidro,
      imagesMina,
      imagesTrituracion,
      showLightbox,
      currentImage,
      openLightbox,
      closeLightbox,
      openModalVideo,
      isVisibleVideoU,
      closeModalVideo,
      videoSection,
      v_gallery_a,
      v_gallery_b,
      v_gallery_c,
      deleteVideo, // Nueva función
      getEmbedUrl,
    };
  },
});
</script>

<style scoped>
.operations-page {
  font-family: "Now Regular";
  color: #333;
  line-height: 1.6;
}

/* Hero Section */
.about-hero {
  height: 60vh;
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url("https://api3.cobredelmayo.com/api/public/img/bg-about.jpg")
      center/cover no-repeat;
  display: flex !important;
  align-items: end !important;
  justify-content: start !important;
  text-align: end !important;
  color: white !important;
  position: relative;
}

.hero-overlay {
  z-index: 1;
}

.about-hero h1 {
  font-size: 3.5rem;
  margin-bottom: 1rem;
  border: 0px solid transparent;
}

/* Gallery Section */
.gallery-section {
  background-color: #f8f9fa;
}

.gallery-container {
  margin-top: 32px;
}

.gallery-container:last-child {
  padding-bottom: 0;
  /* Elimina el padding extra del último contenedor */
}

.gallery-title {
  text-align: start;
  margin-bottom: 40px;
  color: #2c3e50;
  font-size: 2rem;
  position: relative;
  padding-bottom: 15px;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.gallery-item {
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}

.gallery-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.gallery-image {
  width: 100%;
  height: 250px;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.gallery-item:hover .gallery-image {
  transform: scale(1.05);
}

/* Estilos para el contenedor de video con botón de eliminar */
.video-container {
  position: relative;
}

.delete-video-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  background-color: #dc3545;
  border: 2px solid #dc3545;
  border-radius: 50%;
  color: white;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.delete-video-btn:hover {
  background-color: #c82333;
  border-color: #c82333;
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.delete-video-btn:active {
  transform: scale(0.95);
}

/* Lightbox Styles */
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.lightbox-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.lightbox-content img {
  max-width: 100%;
  max-height: 80vh;
  display: block;
  margin: 0 auto;
  border-radius: 8px;
}

.close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: white;
  font-size: 2.5rem;
  cursor: pointer;
  padding: 0 10px;
}

.close-btn:hover {
  color: orange;
}

@media (max-width: 768px) {
  .gallery-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }

  .gallery-title {
    font-size: 1.5rem;
  }

  .about-hero h1 {
    font-size: 2.5rem;
  }

  .gallery-container {
    padding-bottom: 40px;
  }

  .delete-video-btn {
    width: 28px;
    height: 28px;
    font-size: 16px;
    top: 6px;
    right: 6px;
  }
}

/* Estilos de la tarjeta */
.language-tag {
  font-size: 0.75rem;
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 6px;
  border-radius: 4px;
}

.action-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.secondary-btn {
  background: #f59e0b;
  color: white;
}

.secondary-btn:hover {
  background: #d97706;
  box-shadow: 0 4px 6px rgba(245, 158, 11, 0.3);
}
</style>
